import { CsiImage, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";
import imageLS from "./LandscapeSmallImage.jpg";
import imagePS from "./PortraitSmallImage.jpg";

export default () => {
	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="landscape" />
			<Text semiBold text="portrait" />
			<CsiImage size="medium" src={imageLS} />
			<CsiImage size="medium" src={imagePS} />
		</CssColumnGrid>
	);
};